/** Every decision is in `lib/password.ts` (`passwordChecks`) and tested there; this file only draws it. */
import { useTranslation } from 'react-i18next'

import { type PasswordContext, passwordChecks, passwordRuleText } from '../lib/password'

export default function PasswordChecklist({ password, context }: { password: string; context: PasswordContext }) {
  const { t } = useTranslation()
  const checks = passwordChecks(password, context)
  const started = password !== ''
  return (
    <ul className="space-y-0.5 text-xs" aria-label={t('password.rulesTitle')}>
      {checks.map(({ id, ok }) => {
        const met = started && ok
        return (
          <li
            key={id}
            className={
              met
                ? 'flex items-start gap-1.5 text-emerald-700 dark:text-emerald-400'
                : 'flex items-start gap-1.5 text-slate-500 dark:text-slate-400'
            }
          >
            <span aria-hidden="true">{met ? '✓' : '○'}</span>
            <span className="sr-only">{met ? t('password.ruleMet') : t('password.ruleNotMet')}</span>
            <span>{passwordRuleText(t, id)}</span>
          </li>
        )
      })}
      <li className="flex items-start gap-1.5 text-slate-500 dark:text-slate-400">
        <span aria-hidden="true">○</span>
        <span>{passwordRuleText(t, 'common')}</span>
      </li>
    </ul>
  )
}
